import { getLabelRegiaoAnatomica } from 'helpers/labels'
import { formatStringList } from 'utils/helpers'

export const Utils = {

    formatarExameLocal: (exameLocal) => ({
        numeroExame: exameLocal.exReal.numeroExame,
        tipoExame: exameLocal?.exReal?.exSol?.tipoEx?.nome,
        horarios: [
            { label: 'ACIONAMENTO DA EQUIPE', value: exameLocal.dataAcionamento },
            { label: 'INICIO DO DESLOCAMENTO', value: exameLocal.dataDeslocamento },
            { label: 'CHEGADA AO LOCAL', value: exameLocal.dataChegada },
            { label: 'CONCLUSÃO DO EXAME', value: exameLocal.dataConclusao }
        ],
        ocorrencia: [
            { md: 12, label: 'IDENTIFICAÇÃO DA EQUIPE', value: exameLocal.equipeAtendimento },
            { md: 8, label: 'RELATO PRELIMINAR', value: exameLocal.relatoPreliminar },
            { md: 4, label: 'FONTE DO RELATO', value: exameLocal.fonteRelato },
            { md: 12, label: 'INFORMAÇÕES ADICIONAIS', value: exameLocal.outrasInformacoes }
        ]
    }),

    formatarLocais: (locais) => ({
        locais: (locais || [])?.map(local => {
            const coordenadas = (local?.local?.latitudeGps && local?.local?.longitudeGps)
                ? `${local.local.latitudeGps}, ${local.local.longitudeGps}`
                : null
            const endereco = [
                local?.local?.rua,
                local?.local?.numero,
                local?.local?.bairro,
                local?.local?.cep,
                local?.local?.cidade,
                local?.local?.complemento
            ].filter(Boolean)?.join(', ')
            return [
                { md: 8, label: 'DESCRIÇÃO', value: local?.descricao, required: true },
                { md: 4, label: 'COORDENADAS GEOGRÁFICAS', value: coordenadas, required: true },
                { md: 6, label: 'ENDEREÇO', value: endereco, required: true },
                { md: 6, label: 'CLASSIFICAÇÃO', value: local?.caracteristicas, required: true },
                { md: 6, label: 'AUTORIDADE POLICIAL PRESENTE', value: local?.autoridadePolicialPresente, required: true },
                { md: 6, label: 'IDENTIFICAÇÃO DA AUTORIDADE POLICIAL', value: local?.identificacaoAutoridadePolicial, required: true },
                { md: 4, label: 'TIPO DO LOCAL', value: local?.tipoLocalInputText || local?.tipoLocal, required: true },
                { md: 4, label: 'ISOLAMENTO', value: local?.isolamento, required: true },
                { md: 4, label: 'IDONEIDADE', value: local?.idoneidade, required: true },
                // { md: 4, label: 'PRESENÇA DE POPULARES', value: local?.populares },
                { md: 4, label: 'POLÍCIA MILITAR PRESENTE', value: local?.policiaMilitarPresente },
                { md: 4, label: 'IDENTIFICAÇÃO DOS POLICIAIS MILITARES', value: local?.identificacaoPoliciaMilitar },
                { md: 4, label: 'MOMENTO DA CHEGADA DA POLÍCIA CIVIL', value: local?.chegadaPoliciaCivil },
                { md: 4, label: 'IDENTIFICAÇÃO DOS AGENTES DA POLÍCIA', value: local?.identificacaoAgentesPolicia },
                { md: 4, label: 'ÓRGÃO RESPONSÁVEL PELO ISOLAMENTO', value: local?.orgaoIsolamento },
                { md: 4, label: 'RESPONSÁVEIS PELO ISOLAMENTO', value: local?.responsaveisIsolamento },
                { md: 4, label: 'ÁREA ISOLADA NA CHEGADA', value: local?.areaIsoladaAnterior },
                { md: 4, label: 'PRESENTES NO INTERIOR DA ÁREA ISOLADA', value: local?.presentesAreaIsolada },
                { md: 4, label: 'NOVA ÁREA ISOLADA APÓS A CHEGADA', value: local?.areaIsoladaPosterior },

                { md: 4, label: 'ILUMINAÇÃO', value: local?.tipoIluminacao },
                { md: 4, label: 'CONDIÇÕES DO TEMPO DURANTE O EXAME', value: local?.tipoTempo },
                { md: 4, label: 'VISIBILIDADE', value: local?.tipoVisibilidade },
                { md: 4, label: 'DELIMITAÇÕES DO LOCAL', value: local?.delimitacoesLocal },
                { md: 4, label: 'ENTORNO DO LOCAL', value: local?.entornoLocal },
                { md: 4, label: 'TIPO DE PISO', value: local?.tipoPiso },
                { md: 4, label: 'CÂMERAS DE MONITORAMENTO', value: local?.camerasMonitoramento },

                { md: 4, label: 'TIPO DA RODOVIA', value: local?.rodoviaTipo },
                { md: 4, label: 'SENTIDO DA RODOVIA', value: local?.rodoviaSentido },
                { md: 4, label: 'NÍVEL DA RODOVIA', value: local?.rodoviaNivel },
                { md: 4, label: 'REFERÊNCIA DA ORIGEM DA RODOVIA (ATRÁS)', value: local?.rodoviaReferenciaOrigem },
                { md: 4, label: 'REFERÊNCIA DO DESTINO DA RODOVIA (A FRENTE)', value: local?.rodoviaReferenciaDestino },
                { md: 4, label: 'KM DA RODOVIA', value: local?.rodoviaKm },
                { md: 4, label: 'REVESTIMENTO DO PAVIMENTO', value: local?.rodoviaRevestimento },
                { md: 4, label: 'DEFEITOS IDENTIFICADOS NA RODOVIA', value: local?.rodoviaDefeitos },
                { md: 4, label: 'QUANTIDADE DE FAIXAS DE ROLAMENTO', value: local?.rodoviaNumeroFaixas },
                { md: 4, label: 'LARGURA DAS FAIXAS DE ROLAMENTO', value: local?.rodoviaLarguraFaixas },
                { md: 4, label: 'SINALIZAÇÃO HORIZONTAL PRESENTE NA RODOVIA', value: local?.rodoviaSinalizacaoHorizontal },
                { md: 4, label: 'COR DA LINHA DE DIVISÃO DE FLUXO', value: local?.rodoviaCorLinhaDivisao },
                { md: 4, label: 'CONTINUIDADE DA LINHA DE DIVISÃO DE FLUXO', value: local?.rodoviaContinuidadeLinhaDivisao },
                { md: 4, label: 'OBJETOS NA LINHA DE DIVISÃO DE FLUXO', value: local?.rodoviaObjetosLinhaDivisao },
                { md: 4, label: 'COR DA LINHA DE BORDO', value: local?.rodoviaCorLinhaBordo },
                { md: 4, label: 'CONTINUIDADE DA LINHA DE BORDO', value: local?.rodoviaContinuidadeLinhaBordo },
                { md: 4, label: 'OBJETOS NA LINHA DE BORDO', value: local?.rodoviaObjetosLinhaBordo },
                { md: 4, label: 'TRECHO DA RODOVIA NO LOCAL DO EXAME', value: local?.rodoviaTipoTrecho },
                { md: 4, label: 'DESENVOLVIMENTO DA RODOVIA NO LOCAL DO EXAME', value: local?.rodoviaDesenvolvimento },
                { md: 4, label: 'INCLINAÇÃO DA RODOVIA NO LOCAL DE EXAME', value: local?.rodoviaInclinacao },
                { md: 4, label: 'SEÇÃO TRANSVERSAL DA RODOVIA', value: local?.rodoviaSecao },
                { md: 4, label: 'ELEMENTOS NA LATERAL DIREITA DA RODOVIA', value: local?.rodoviaElementosLadoDireito },
                { md: 4, label: 'ELEMENTOS NA LATERAL ESQUERDA DA RODOVIA', value: local?.rodoviaElementosLadoEsquerdo },
                { md: 4, label: 'LARGURA DO ACOSTAMENTO DO LADO DIREITO', value: local?.rodoviaLarguraAcostamentoDireita },
                { md: 4, label: 'LARGURA DO ACOSTAMENTO DO LADO ESQUERDO', value: local?.rodoviaLarguraAcostamentoEsquerda },
                { md: 4, label: 'MARGEM DIREITA DA RODOVIA', value: local?.rodoviaMargemDireita },
                { md: 4, label: 'MARGEM ESQUERDA DA RODOVIA', value: local?.rodoviaMargemEsquerda },
                { md: 4, label: 'LIMITE DE VELOCIDADE NO SENTIDO AO DESTINO', value: local?.rodoviaLimiteVelocidadeOrigem },
                { md: 4, label: 'FORMA DE VERIFICAÇÃO NO LIMITE DE VELOCIDADE NO SENTIDO AO DESTINO', value: local?.rodoviaSinalizacaoVelocidadeOrigem },
                { md: 4, label: 'DISTÂNCIA DA SINALIZAÇÃO DE VELOCIDADE NO SENTIDO AO DESTINO', value: local?.rodoviaDistanciaSinalizacaoVelocidadeOrigem },
                { md: 4, label: 'OBSERVAÇÕES DA VELOCIDADE NO SENTIDO AO DESTINO', value: local?.rodoviaObservacoesVelocidadeOrigem },
                { md: 4, label: 'LIMITE DE VELOCIDADE NO SENTIDO OPOSTO (À ORIGEM)', value: local?.rodoviaLimiteVelocidadeDestino },
                { md: 4, label: 'FORMA DE VERIFICAÇÃO NO LIMITE DE VELOCIDADE NO SENTIDO OPOSTO (À ORIGEM)', value: local?.rodoviaSinalizacaoVelocidadeDestino },
                { md: 4, label: 'DISTÂNCIA DA SINALIZAÇÃO DE VELOCIDADE NO SENTIDO OPOSTO (À ORIGEM)', value: local?.rodoviaDistanciaSinalizacaoVelocidadeDestino },
                { md: 4, label: 'OBSERVAÇÕES DA VELOCIDADE NO SENTIDO OPOSTO (À ORIGEM)', value: local?.rodoviaObservacoesVelocidadeDestino },

                { md: 4, label: 'TIPO DO IMÓVEL', value: local?.imovelClassificacao },
                { md: 4, label: 'TIPO DE ACESSO AO IMÓVEL', value: local?.imovelTipoAcesso },
                { md: 4, label: 'FORMA DE ACESSO AO IMÓVEL', value: local?.imovelFormaAcesso },
                { md: 4, label: 'PAVIMENTOS EXISTENTES DO IMÓVEL', value: local?.imovelPavimentos },
                { md: 4, label: 'ÁREAS EXTERNAS DO IMÓVEL', value: local?.imovelAreasExternas },
                { md: 4, label: 'FACHADAS DO IMÓVEL', value: local?.imovelFachadas },
                { md: 4, label: 'JANELAS DO IMÓVEL', value: local?.imovelJanelas },
                { md: 4, label: 'CÔMODOS DO IMÓVEL', value: local?.imovelComodos },
                { md: 4, label: 'CARACTERÍSTICAS CONSTRUTIVAS DO IMÓVEL', value: local?.imovelCaracteristicasConstrutivas },
                { md: 4, label: 'PROJETOS DO IMÓVEL ANALISADOS', value: local?.imovelProjetos },
                { md: 4, label: 'VIZINHANÇA DO IMÓVEL', value: local?.imovelVizinhanca },

                { md: 4, label: 'SINAIS DE ARROMBAMENTO', value: local?.sinaisArrombamento },
                { md: 4, label: 'SINAIS DE DESTELHAMENTO', value: local?.sinaisDestelhamento },
                { md: 4, label: 'SINAIS DE ESCALADA', value: local?.sinaisEscalada },
                { md: 4, label: 'SINAIS DE DESALINHO', value: local?.sinaisDesalinho },
                { md: 4, label: 'MARCAS DE IMPACTO', value: local?.marcasImpacto },
                { md: 4, label: 'SINAIS DE INCÊNDIO', value: local?.incendioRegistro },
                { md: 4, label: 'DISPOSITIVOS DE COMBATE A INCÊNDIO', value: local?.incendioDispositivos },
                { md: 4, label: 'BOMBEIROS ESTIVERAM NO LOCAL', value: local?.incendioBombeirosPresentes },
                { md: 4, label: 'CAUSA PROVÁVEL OU ORIGEM DO INCÊNDIO', value: local?.incendioCausaProvavel },
                { md: 4, label: 'OUTRAS INFORMAÇÕES SOBRE O INCÊNDIO', value: local?.incendioOutros },
                { md: 4, label: 'LEVANTAMENTO PAPILOSCÓPICO REALIZADO', value: local?.papiloscopiaLevantamento },
                { md: 4, label: 'LOCAIS DOS LEVANTAMENTOS PAPILOSCÓPICOS', value: local?.papiloscopiaLocais },
                { md: 4, label: 'MATERIAL EMPREGADO NO LEVANTAMENTO PAPILOSCÓPICO', value: local?.papiloscopiaMaterial },
                { md: 4, label: 'OUTROS EXAMES REALIZADOS NO LOCAL', value: local?.examesOutros },

                { md: 12, label: 'INFORMAÇÕES ADICIONAIS DO LOCAL', value: local?.informacoesAdicionais }
            ]
        })
    }),

    formatarVestigios: (vestigios) => ({
        vestigios: (vestigios || [])?.map(vestigio => {
            const endereco = [
                vestigio?.local?.rua,
                vestigio?.local?.numero,
                vestigio?.local?.bairro,
                vestigio?.local?.cep,
                vestigio?.local?.cidade,
                vestigio?.local?.complemento
            ].filter(Boolean)?.join(', ')
            return [
                { md: 4, label: 'TIPO', value: vestigio?.tipoInputText || vestigio?.tipo?.nome, required: true },
                { md: 8, label: 'LOCAL', value: endereco },
                { md: 4, label: 'LOCALIZAÇÃO', value: vestigio?.localizacao },
                { md: 4, label: 'QUANTIDADE', value: vestigio?.quantidade },
                { md: 4, label: 'FABRICANTE', value: vestigio?.marca },
                { md: 4, label: 'CALIBRE NOMINAL', value: vestigio?.calibre },
                { md: 4, label: 'LACRE DE ACONDICIONAMENTO', value: vestigio?.vestCol?.lacre },
                { md: 12, label: 'INFORMAÇÕES ADICIONAIS', value: vestigio?.observacao },
            ]
        })
    }),

    formatarCadaveres: (cadaveres) => ({
        cadaveres: (cadaveres || [])?.map(cadaver => {
            const endereco = [
                cadaver?.cadaver?.endOrig?.rua,
                cadaver?.cadaver?.endOrig?.numero,
                cadaver?.cadaver?.endOrig?.bairro,
                cadaver?.cadaver?.endOrig?.cep,
                cadaver?.cadaver?.endOrig?.cidade,
                cadaver?.cadaver?.endOrig?.complemento
            ].filter(Boolean)?.join(', ')
            const analiseCadaver = [
                { md: 4, label: 'NIC', value: cadaver?.cadaver?.nic, required: true },
                { md: 8, label: 'LOCAL', value: endereco },
                { md: 4, label: 'LOCALIZAÇÃO', value: cadaver?.localizacao },
                { md: 4, label: 'POSIÇÃO', value: cadaver?.posicaoInputText || cadaver?.posicao },
                { md: 4, label: 'SEXO', value: cadaver?.sexo },
                { md: 4, label: 'ETNIA', value: cadaver?.etnia },
                { md: 4, label: 'FAIXA ETÁRIA', value: cadaver?.faixaEtaria },
                { md: 4, label: 'CABELO', value: cadaver?.cabelo },
                { md: 4, label: 'BARBA E BIGODE', value: cadaver?.barbaBigode },
                { md: 8, label: 'VESTIMENTAS', value: cadaver?.vestimentas },
                { md: 4, label: 'PERTENCES', value: cadaver?.pertences },
                { md: 4, label: 'ENTREGA DOS PERTENCES', value: cadaver?.entregaPertences },
                { md: 6, label: 'MARCAS CORPORAIS / CICATRIZES', value: cadaver?.cicatrizes },
                { md: 6, label: 'TATUAGENS', value: cadaver?.tatuagens },
            ]
            const fenomenos = formatarFenomenosCadavericos(cadaver?.cadaver?.fenomCads);
            if (fenomenos?.values?.length > 0) analiseCadaver.push(
                { md: 12, label: 'FENÔMENOS CADAVÉRICOS', table: true, required: true, headers: fenomenos?.headers, values: fenomenos?.values },
            )
            const lesoes = formatarLesoes(cadaver?.cadaver?.lesoes);
            if (lesoes?.values?.length > 0) analiseCadaver.push(
                { md: 12, label: 'LESÕES', table: true, required: true, headers: lesoes?.headers, values: lesoes?.values },
            )
            analiseCadaver.push(
                { md: 12, label: 'INFORMAÇÕES ADICIONAIS', value: cadaver?.informacoesAdicionais }
                // { md: 12, label: 'RAW', value: JSON.stringify(cadaver) }
            )
            return analiseCadaver;
        })
    })


}

const formatarFenomenosCadavericos = fenomenosCadavericos => {
    const values = (fenomenosCadavericos || []).map(fc => ([
        fc?.tipoTextoLivre || fc?.tipo?.nome,
        fc?.observacoes || "-",
    ])).filter(Boolean);
    const headers = [
        { label: 'TIPO', minSize: '40%' },
        { label: 'OBSERVAÇÕES', minSize: '40%' },
    ]
    return { values, headers }
}

const formatarLesoes = lesoes => {
    const values = (lesoes || []).map(l => {
        let regiao = (l?.regioesTextoLivre || getLabelRegiaoAnatomica(l?.regioes[0])).trim();
        if (l?.regioesSecundariasTextoLivre?.trim()) {
            regiao = [regiao, l?.regioesSecundariasTextoLivre?.trim()]?.filter(Boolean)?.join(', ')
        }
        return [
            l?.tipoTextoLivre || l?.tipo?.nome,
            regiao || "-",
            l?.medida != undefined ? `${l?.medida} mm` : "-",
            formatarCaracteristicas(l) || "-",
            l?.observacoes || "-",
        ]
    }).filter(Boolean);
    const headers = [
        { label: 'TIPO' },
        { label: 'REGIÃO ANATÔMICA' },
        { label: 'MEDIDA' },
        { label: 'CARACTERÍSTICAS' },
        { label: 'OBSERVAÇÕES' },
    ]
    return { values, headers }
}

const formatarCaracteristicas = (lesao) => {
  let caracteristicas = [];
  if (lesao["tipoCogumeloEspuma"] === "SANGUINOLENTO") caracteristicas.push("aspecto sanquinolento");
  if (lesao["tipoCogumeloEspuma"] === "NÃO SANGUINOLENTO") caracteristicas.push("aspecto não sanguinolento");
  if (lesao["sulcoOrientacao"] === "OBLÍQUO ASCENDENTE") caracteristicas.push("sulco oblíquo ascendente");
  if (lesao["sulcoOrientacao"] === "HORIZONTALIZADO") caracteristicas.push("sulco horizontalizado");
  if (lesao["sulcoMultiplicidade"] === "ÚNICO") caracteristicas.push("sulco único");
  if (lesao["sulcoMultiplicidade"] === "DUPLO") caracteristicas.push("sulco duplo");
  if (lesao["sulcoMultiplicidade"] === "TRIPLO") caracteristicas.push("sulco triplo");
  if (lesao["sulcoMultiplicidade"] === "MÚLTIPLO") caracteristicas.push("múltiplos sulcos");
  if (lesao["sulcoContinuidade"] === "CONTÍNUO") caracteristicas.push("sulco contínuo");
  if (lesao["sulcoContinuidade"] === "DESCONTÍNUO") caracteristicas.push("sulco descontínuo");
  if (lesao["sulcoTonalidade"] === "VIOLÁCEO") caracteristicas.push("tonalidade violácea");
  if (lesao["sulcoTonalidade"] === "PÁLIDO") caracteristicas.push("tonalidade pálida");
  if (lesao["sulcoTonalidade"] === "AZULADO") caracteristicas.push("tonalidade azulada");
  if (lesao["sulcoTonalidade"] === "PARDO ESCURO") caracteristicas.push("tonalidade pardo-escura");
  if (lesao["sulcoProfundidade"] === "UNIFORME") caracteristicas.push("profundidade uniforme");
  if (lesao["sulcoProfundidade"] === "DESIGUAL") caracteristicas.push("profundidade desigual");
  if (lesao["sulcoTumefeito"]) caracteristicas.push("sulco tumefeito");
  if (lesao["sulcoMargensElevadas"]) caracteristicas.push("margens elevadas");
  if (lesao["sulcoLeitoDeprimido"]) caracteristicas.push("leito deprimido");
  if (lesao["sulcoPeleEnrugada"]) caracteristicas.push("pele enrugada");
  if (lesao["incisaoRegiaoMaisAprofundada"] === "À ESQUERDA") caracteristicas.push("maior profundidade à esquerda");
  if (lesao["incisaoRegiaoMaisAprofundada"] === "À DIREITA") caracteristicas.push("maior profundidade à direita");
  if (lesao["incisaoRegiaoMaisAprofundada"] === "ACIMA") caracteristicas.push("maior profundidade acima");
  if (lesao["incisaoRegiaoMaisAprofundada"] === "ABAIXO") caracteristicas.push("maior profundidade abaixo");
  if (lesao["incisaoRegiaoCaudaEscoriacao"] === "À ESQUERDA") caracteristicas.push("cauda de escoriação à esquerda");
  if (lesao["incisaoRegiaoCaudaEscoriacao"] === "À DIREITA") caracteristicas.push("cauda de escoriação à direita");
  if (lesao["incisaoRegiaoCaudaEscoriacao"] === "ACIMA") caracteristicas.push("cauda de escoriação acima");
  if (lesao["incisaoRegiaoCaudaEscoriacao"] === "ABAIXO") caracteristicas.push("cauda de escoriação abaixo");
  if (lesao["incisaoBorda"] === "RETRAÍDA") caracteristicas.push("bordas retraídas");
  if (lesao["incisaoBorda"] === "NÃO RETRAÍDA") caracteristicas.push("bordas não retraídas");
  if (lesao["perfuroIncisaForma"] === "BOTEIRA") caracteristicas.push("formato de botoeira");
  if (lesao["perfuroIncisaForma"] === "BICONVEXA") caracteristicas.push("formato biconvexo");
  if (lesao["tipoQueimaduraEletrica"] === "TIPO AFRANTUOSO") caracteristicas.push("tipo afrantuoso");
  if (lesao["tipoQueimaduraEletrica"] === "TIPO CAVITÁRIO") caracteristicas.push("tipo cavitário");
  if (lesao["tipoQueimaduraEletrica"] === "TIPO POROSO") caracteristicas.push("tipo poroso");
  if (lesao["metalizacao"]) caracteristicas.push("metalicação");
  if (lesao["eritema"]) caracteristicas.push("eritema");
  if (lesao["flictema"]) caracteristicas.push("flictema");
  if (lesao["carbonizacao"]) caracteristicas.push("carbonização");
  if (lesao["necrose"]) caracteristicas.push("necrose");
  if (lesao["pafTipoBorda"] === "INVERTIDA") caracteristicas.push("bordas invertidas");
  if (lesao["pafTipoBorda"] === "INVERTIDA IRREGULAR") caracteristicas.push("bordas invertidas irregulares");
  if (lesao["pafTipoBorda"] === "EVERTIDA") caracteristicas.push("bordas evertidas");
  if (lesao["pafTipoBorda"] === "EVERTIDA IRREGULAR") caracteristicas.push("bordas evertidas irregulares");
  if (lesao["pafHaloEnxugo"]) caracteristicas.push("halo de enxugo");
  if (lesao["pafAureolaEquimotica"]) caracteristicas.push("auréola equimótica");
  if (lesao["pafOrlaEscoriacao"]) caracteristicas.push("orla de escoriação");
  if (lesao["pafZonaTatuagem"]) caracteristicas.push("zona de tatuagem");
  if (lesao["pafZonaEsfumacamento"]) caracteristicas.push("zona de esfumaçamento");
  if (lesao["pafZonaQueimadura"]) caracteristicas.push("zona de queimadura");
  if (lesao["pafAspectoEstrelado"]) caracteristicas.push("aspecto estrelado");
  if (lesao["pafMarcaCano"]) caracteristicas.push("marca do cano");
  if (lesao?.outrasCaracteristicasTextoLivre?.length > 0) caracteristicas.push(lesao?.outrasCaracteristicasTextoLivre);
  return formatStringList(caracteristicas?.join(', '));
}
